cb.define(['common/common_VM.Extend.js'], function (common) {
  var AA_aa_warehouselist_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      common.initRegionAndPosition(viewmodel);
    }
  }
  try {
    module.exports = AA_aa_warehouselist_filterVM_Extend;
  } catch (error) {

  }
  return AA_aa_warehouselist_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_warehouselist_filterVM.Extend.js